import React, { useEffect, useState, useRef } from "react";

import { Col, Row } from "react-bootstrap";
import { formatImageUrl } from "../../../helper/helper";
import Button from "../common/CommonButton/Button";

const NewOctaveWhiskyCollection = (props: any) => {
  const { data, meta } = props;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Name (A - Z)");
  const [selectedOption, setSelectedOption]: any = useState(null);
  const [mainData, setMainData]: any = useState(data?.data || []);
  const [filterOptions, setFilterOptions] = useState<any>({
    region: [],
    age: [],
    distillery: [],
    // cask: [],
  });
  const [searchCask, setSearchCask] = useState("");

  //overlay
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeAcc, setActiveAcc]: any = useState<string | null>(null);
  const [tempFilters, setTempFilters]: any = useState({
    region: [],
    collection: [],
    age: [],
    distillery: [],
    // cask: [],
  });
  const filterTopRef = useRef<HTMLDivElement | null>(null);
  const isFirstRender = useRef(true);
  const shouldScrollRef = useRef(false);

  const toggleAcc = (key: string) => {
    setActiveAcc(activeAcc === key ? null : key);
  };

  useEffect(() => {
    if (!mainData.length) return;

    const regionSet: any = new Set<string>();
    const ageSet: any = new Set<string>();
    const distillerySet: any = new Set<string>();
    // const caskSet: any = new Set<string>();

    mainData.forEach((item: any) => {
      let a = item.attributes;

      if (a.region) regionSet.add(a.region);
      if (a.age) ageSet.add(a.age);
      if (a.distillery) distillerySet.add(a.distillery);
      // if (a.cask_details) caskSet.add(a.cask_details);
    });

    setFilterOptions({
      region: [...regionSet],
      age: [...ageSet],
      distillery: [...distillerySet],
      // cask: [...caskSet],
    });
  }, [mainData]);

  // selected filters
  const [filters, setFilters] = useState<any>({
    region: [],
    collection: [],
    age: [],
    distillery: [],
    // cask: [],
  });

  // const toggleAcc = (key: string) => {
  //   setActiveAcc(activeAcc === key ? null : key);
  // };

  const handleFilterChange = (type: string, value: string) => {
    setFilters((prev: any) => {
      const alreadySelected = prev[type].includes(value);

      return {
        ...prev,
        [type]: alreadySelected
          ? prev[type].filter((item: any) => item !== value)
          : [...prev[type], value],
      };
    });
  };

  const matches = (value: any, selectedList: any[]) => {
    if (!selectedList || selectedList.length === 0) return true;
    return selectedList.includes(value);
  };

  const applyFiltering = (products: any) => {
    return products.filter((item: any) => {
      const attrs = item.attributes;

      // Convert to string so number types also match
      const caskValue =
        attrs?.cask_details?.toString()?.trim()?.toLowerCase() || "";
      const searchValue = searchCask.toString().trim().toLowerCase();

      return (
        matches(attrs.region, filters.region) &&
        matches(attrs.age, filters.age) &&
        matches(attrs.distillery, filters.distillery) &&
        // matches(attrs.cask_details, filters.cask) &&
        // contains match instead of startsWith (IMPORTANT)
        (searchValue === "" || caskValue.includes(searchValue))
      );
    });
  };

  const sortProducts = (products: any) => {
    if (!selectedOption) return products;

    const getPriceAsNumber = (priceString: any) => {
      const numericString = priceString?.replace(/[^0-9.-]+/g, "");
      return parseFloat(numericString);
    };

    switch (selectedOption.value) {
      case "price_low_to_high":
        return [...products].sort((a, b) => {
          const priceA = getPriceAsNumber(a?.attributes?.price || "0");
          const priceB = getPriceAsNumber(b?.attributes?.price || "0");
          return priceA - priceB;
        });

      case "price_high_to_low":
        return [...products].sort((a, b) => {
          const priceA = getPriceAsNumber(a?.attributes?.price || "0");
          const priceB = getPriceAsNumber(b?.attributes?.price || "0");
          return priceB - priceA;
        });

      case "name_a_to_z":
        return [...products].sort((a, b) =>
          (a?.attributes?.name || "").localeCompare(b?.attributes?.name || "")
        );

      case "name_z_to_a":
        return [...products].sort((a, b) =>
          (b?.attributes?.name || "").localeCompare(a?.attributes?.name || "")
        );

      default:
        return products;
    }
  };

  const clearAllFilters = () => {
    setFilters({
      region: [],
      collection: [],
      age: [],
      distillery: [],
      // cask: [],
    });
    setDrawerOpen(false);
  };

  const getSelectedChips = () => {
    let chips: any[] = [];
    Object.keys(filters).forEach((key) => {
      filters[key].forEach((item: string) => {
        chips.push({ type: key, value: item });
      });
    });
    return chips;
  };

  const removeSingleFilter = (type: string, value: string) => {
    setFilters((prev: any) => ({
      ...prev,
      [type]: prev[type].filter((f: string) => f !== value),
    }));
  };

  useEffect(() => {
    const originalList =
      props?.data?.collection_groups?.data?.[0]?.attributes?.collection_lists
        ?.data ?? [];

    setMainData(originalList);
  }, [props?.data]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const sortBox = document.querySelector(".custom-select");
      const dropdown = document.querySelector(".select-dropdown");

      // If dropdown open & click outside
      if (open && dropdown && !sortBox?.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [open]);

  // Disable scroll ONLY when user opens filter drawer manually
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (drawerOpen) {
      const scrollY = window.scrollY; // store current position
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.width = "100%";

      return () => {
        body.style.position = "";
        body.style.top = "";
        window.scrollTo(0, scrollY); // restore scroll EXACTLY where user was
      };
    }
  }, [drawerOpen]);

  // const sortedProducts: any = sortProducts(mainData);
  const filteredProducts = applyFiltering(mainData);
  const sortedProducts: any = sortProducts(filteredProducts);
  const [itemsPerPage, setItemsPerPage] = useState(4);

  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 4;

  const totalItems = sortedProducts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = sortedProducts.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // ↓ Function to generate compact pagination numbers
  const getPaginationNumbers = () => {
    const pages = [];

    if (totalPages <= 6) {
      // If very few pages → show all
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    if (currentPage <= 3) {
      return [1, 2, 3, "...", totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [1, "...", totalPages - 2, totalPages - 1, totalPages];
    }

    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  useEffect(() => {
    const handleResize = () => {
      // iPad & iPad Pro (portrait + landscape)
      if (window.innerWidth >= 768 && window.innerWidth <= 1199) {
        setItemsPerPage(3);
      } else {
        setItemsPerPage(4);
      }
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!shouldScrollRef.current) return;

    shouldScrollRef.current = false;

    filterTopRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [currentPage]);

  return (
    <div
      style={{ position: "relative" }}
      id="explore-range-section"
      className="new-octave-whisky-collection-outerwrapper"
    >
      <section className="new_octave_whisky_collection_section">
        <div className={"new_octave_collection_title"}>
          {props?.data?.header}
        </div>

        <div
          className="collection_container"
          id="collection-card-div"
          ref={filterTopRef}
        >
          <div className="new_octave_collection_card_section">
            <h3 className="description">{props?.data?.description}</h3>

            {/* filter */}
            <div className="filters-bar">
              <button
                className="filter-btn"
                onClick={() => {
                  setTempFilters(JSON.parse(JSON.stringify(filters)));
                  setDrawerOpen(true);
                }}
              >
                <span>Filters</span>
                <img
                  src="/octave-collection-new/filter.svg"
                  alt="filter icon"
                />
              </button>
              <div className="sort-wrapper">
                <label>Sort by:</label>

                <div className="custom-select" onClick={() => setOpen(!open)}>
                  <span>{selected}</span>
                  <img src="/octave-collection-new/drawer-arrow.svg" alt="" />
                </div>

                {open && (
                  <ul className="select-dropdown">
                    {[
                      // {
                      //   value: "recommended",
                      //   label: "Recommended",
                      // },

                      { value: "name_a_to_z", label: "Name (A - Z)" },
                      { value: "name_z_to_a", label: "Name (Z - A)" },
                    ].map((item: any) => (
                      <li
                        key={item?.label}
                        onClick={() => {
                          setSelected(item?.label);
                          setSelectedOption(item);

                          setOpen(false);
                        }}
                      >
                        {item?.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {!props?.hideCaskNo && (
              <div className="search-box">
                <div className="search-wrapper">
                  <span className="search-label">Search by Cask Number:</span>

                  <input
                    type="text"
                    className="search-input"
                    placeholder="Enter Cask Number"
                    value={searchCask}
                    onChange={(e) => {
                      setSearchCask(e.target.value);
                      setCurrentPage(1);
                    }}
                  />

                  {searchCask.length > 0 ? (
                    <img
                      src="/octave-collection-new/cross.png"
                      className="clear-search-icon"
                      onClick={() => {
                        setSearchCask("");
                        setCurrentPage(1); // reset page after clearing search
                      }}
                    />
                  ) : (
                    <img
                      src="/octave-collection-new/search-icon.svg"
                      className="search-icon"
                      alt="search"
                    />
                  )}
                </div>
              </div>
              )}
            </div>

            {/* OVERLAY */}
            {drawerOpen && (
              <div
                className="overlay"
                onClick={() => setDrawerOpen(false)}
              ></div>
            )}

            {/* SIDE DRAWER */}
            <div className={`filter-drawer ${drawerOpen ? "open" : ""}`}>
              <div className="drawer-inner-wrapper">
                <div className="drawer-header">
                  <h3>Filters</h3>
                  <span onClick={() => setDrawerOpen(false)}>
                    <img src="/octave-collection-new/close.png" />
                  </span>
                </div>

                <div className="drawer-content">
                  {/* Accordion Sections */}
                  {Object.entries(filterOptions).map(([key, options]: any) => (
                    <div className="accordion-item" key={key}>
                      <div
                        className="acc-header"
                        onClick={() => toggleAcc(key)}
                      >
                        {/* <span>{key.toUpperCase()}</span> */}
                        <span>
                          {key.charAt(0).toUpperCase() + key.slice(1)}
                        </span>
                        <span
                          className={`arrow ${activeAcc === key ? "open" : ""}`}
                        >
                          <img
                            src="/octave-collection-new/drawer-arrow.svg"
                            alt=""
                          />
                        </span>
                      </div>

                      {activeAcc === key && (
                        <div className="acc-body">
                          {options.map((opt: string) => (
                            <label key={opt}>
                              <input
                                type="checkbox"
                                checked={
                                  tempFilters[key]?.includes(opt) || false
                                }
                                onChange={() => {
                                  setTempFilters((prev: any) => {
                                    const exists = prev[key]?.includes(opt);

                                    return {
                                      ...prev,
                                      [key]: exists
                                        ? prev[key].filter(
                                            (v: any) => v !== opt
                                          )
                                        : [...prev[key], opt],
                                    };
                                  });
                                }}
                              />
                              {opt}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* FOOTER BUTTONS */}
              <div className="drawer-footer">
                <button
                  className="apply-btn"
                  onClick={() => {
                    setFilters(tempFilters); // APPLY CHANGES
                    setCurrentPage(1); // reset to page 1
                    setDrawerOpen(false); // close drawer
                  }}
                >
                  APPLY NOW
                </button>
                <button
                  className="clear-btn"
                  onClick={() => {
                    const cleared = {
                      region: [],
                      collection: [],
                      age: [],
                      distillery: [],
                      // cask: [],
                    };
                    setTempFilters(cleared); // clear temp filters
                    setFilters(cleared); // also clear actual filters
                  }}
                >
                  CLEAR FILTERS
                </button>
              </div>
            </div>
            <Row>
              {/* Selected Filter Chips */}
              {/* <div className="selected-chips-wrapper"> */}
              {getSelectedChips().length > 0 && (
                <div className="selected-chips-wrapper">
                  {getSelectedChips().map((chip, index) => (
                    <span className="chip" key={index}>
                      {chip.value}
                      <span
                        onClick={() =>
                          removeSingleFilter(chip.type, chip.value)
                        }
                      >
                        <img src="/octave-collection-new/cross.png" />
                      </span>
                    </span>
                  ))}
                  {getSelectedChips().length > 1 && (
                    <span
                      className="clear-all-chip-btn"
                      onClick={clearAllFilters}
                    >
                      Clear All
                    </span>
                  )}
                </div>
              )}
              {/* </div> */}

              {currentItems?.length > 0 ? (
                currentItems?.map((item: any, index: number) => {
                  let cardImage: any = formatImageUrl(
                    item?.attributes?.image?.data?.attributes?.url
                  );
                  return (
                    <Col xs={6} sm={6} md={4} xl={3} key={index}>
                      <div className="collection_card">
                        <div className="collection_card_img">
                          {item?.attributes?.image?.data && (
                            <img src={cardImage} alt={`collection image`} />
                          )}
                        </div>
                        <div className="collection_card_details">
                          <div className="collection_whisky_data">
                            <h3>{item?.attributes?.name},</h3>
                            <h4>{item?.attributes?.age}</h4>
                            {!props?.hideCaskNo && (
                            <h5 className="cask-number-text">
                              Cask No:
                              {item?.attributes?.cask_details}
                            </h5>
                            )}
                          </div>
                          <div
                            className={`collection_btn_group${
                              props?.hideCaskNo ? " no-cask-gap" : ""
                            }`}
                          >
                            {item?.attributes?.cta?.link ? (
                              <Button
                                // variant="light"
                                btnText={item?.attributes?.cta?.title}
                                btnClass={"btn_view_range"}
                                btnLink={item?.attributes?.cta?.link}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <div className={"new_octave_noresult_title"}>
                  No Products found
                </div>
              )}
              {currentItems?.length > 0 && (
                <div className="pagination">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => {
                      shouldScrollRef.current = true;
                      setCurrentPage(1);
                    }}
                  >
                    First
                  </button>
                  <button
                    disabled={currentPage === 1}
                    onClick={() => {
                      shouldScrollRef.current = true;
                      setCurrentPage((p) => p - 1);
                    }}
                  >
                    Prev
                  </button>

                  {getPaginationNumbers().map((page: any, i) => (
                    <button
                      key={i}
                      disabled={page === "..."}
                      className={page === currentPage ? "active" : ""}
                      // onClick={() => {
                      //   shouldScrollRef.current = true;
                      //   page !== "..." && setCurrentPage(page);
                      // }}
                      onClick={() => {
                        if (page === "...") return;
                        shouldScrollRef.current = true;
                        setCurrentPage(page);
                      }}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => {
                      shouldScrollRef.current = true;
                      setCurrentPage((p) => p + 1);
                    }}
                  >
                    Next
                  </button>
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => {
                      shouldScrollRef.current = true;
                      setCurrentPage(totalPages);
                    }}
                  >
                    Last
                  </button>
                </div>
              )}
            </Row>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewOctaveWhiskyCollection;
